import { formatPkr } from './currency';

export const fmt = (n: number) => formatPkr(n);

export const fmtDate = (s?: string) =>
  s
    ? new Date(s).toLocaleDateString('en-PK', { day: '2-digit', month: 'short', year: 'numeric' })
    : '—';
